import React, { lazy, useEffect } from 'react';
import SectionSkeleton from './sectionskeleton';
import LazySection from 'components/lazySection';
import { useLocation } from 'react-router-dom';
const CareerAbout = lazy(() => import("../components/Career/CareerAbout"));
const CareerBanner = lazy(() => import("../components/Career/CareerBanner"));
const CareerCoreValues = lazy(() => import("../components/Career/CareerCoreValues"));
const CareerDiversity = lazy(() => import("../components/Career/CareerDiversity"));
const CareerJobOpenings = lazy(() => import("../components/Career/CareerJobOpenings"));
const CareerLifeHREPL = lazy(() => import("../components/Career/CareerLifeHREPL"));

const CareerWith: React.FC = () => {
  const location = useLocation();

  const About = location.hash === "#overview" ? location.hash  : "" ;

  const hash = location.hash;
   const diversity = location.hash === "#section-diversity";
  const life = location.hash === "#section-lifeathrepl";
  const job = location.hash === "#job-opening";
   useEffect(() => {
    if (!location.hash) return;

    let attempts = 0;
    const maxAttempts = 20;

    const scrollToHash = () => {
      const element = document.querySelector(location.hash);

      if (element) {
        const y =
          element.getBoundingClientRect().top +
          window.pageYOffset -
          120;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(scrollToHash, 150); // retry
      }
    };

    // small delay to allow render
    setTimeout(scrollToHash, 100);

  }, [location.pathname, location.hash]);


  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
 
    //  <>
    //   {/* Immediate load (important for LCP) */}
    //   <CareerBanner />
     
    //       <CareerAbout  />
       
    //       <CareerCoreValues />
      
    //       <CareerDiversity />
      
    //       <CareerLifeHREPL />
      
    //       <CareerJobOpenings />
        
    // </>

     <>
        <CareerBanner /> 
          {hash  ? (
            <>
                <CareerAbout  />
       
          <CareerCoreValues />
      
           <CareerDiversity />
      
           <CareerLifeHREPL />
      
           <CareerJobOpenings />
            </>
              ) : (
                <>
                    <LazySection fallback={<SectionSkeleton height={300} />}>
                      <CareerAbout />
                    </LazySection>
                    <LazySection fallback={<SectionSkeleton height={350} />}>
                      <CareerCoreValues />
                    </LazySection>
                      <LazySection fallback={<SectionSkeleton height={350} />}>
                        <CareerDiversity />
                      </LazySection>
                        <LazySection fallback={<SectionSkeleton height={350} />}>
                        <CareerLifeHREPL />
                      </LazySection>
                        <LazySection fallback={<SectionSkeleton height={350} />}>
                        <CareerJobOpenings />
                      </LazySection>
              </>
            )}
            
    </> 
  );
};

export default CareerWith;
